import React, { useState, useRef, useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import { useDispatch, useSelector } from 'react-redux';
import { useValidatedInput } from '../../hooks/useValidatedInput';
import { setNativeInputValue } from '../../utils/setNativeInputValue';
import fieldParams from '../../const/fieldParams';
import '../../assets/styles/group-input.sass';

const CodeVerificationInput = ({ fieldKey }) => {
  const { key, type, inputMode, length, errorMessage } = fieldParams[fieldKey];
  const context = useContext(BookerContext);
  const {
    state: { error },
  } = context;
  const { value: storedCode = '' } = useSelector(({ code }) => code || {});
  const dispatch = useDispatch();

  const startingCode = storedCode.length ? [...storedCode] : null;
  let cd = startingCode || [...Array(length)].map(() => '');
  const [code, setCode] = useState(cd);
  const [setIsValid] = useValidatedInput('btn-view', storedCode.length === length);
  const inputs = useRef([]);

  const processInput = (e, slot) => {
    const {
      target: { value },
    } = e;
    const [first, ...rest] = value;

    e.target.value = first ?? '';
    const newCode = code.join('').length ? [...code] : [...cd];
    newCode[slot] = first ?? '';
    cd = [...newCode];
    setCode(newCode);

    if (slot !== length - 1 && first !== undefined) {
      inputs.current[slot + 1].focus();
      const event = new Event('input', { bubbles: true });
      setNativeInputValue(inputs.current[slot + 1], rest.join(''));
      inputs.current[slot + 1].dispatchEvent(event);
    }
    if (newCode.every(num => num !== '')) {
      dispatch({
        type: 'updateCode',
        code: { value: newCode.join('') },
      });
      setIsValid(true);
    }
  };

  const onKeyUp = (e, slot) => {
    if (e.keyCode === 8 && !code[slot]) {
      setIsValid(false);
      if (slot !== 0) {
        inputs.current[slot - 1].focus();
        return;
      }
      dispatch({
        type: 'updateCode',
        code: '',
      });
    }
  };

  return (
    <div className={`form-group form-group-${key}${error === key ? ' error-group' : ''}`}>
      <div className="group-inputs">
        {code.map((num, idx) => {
          return (
            <div key={`input-wrapper-${idx}`} className="group-input-wrapper">
              <label htmlFor={idx} key={`label-${idx}`} className="landmark" />
              <input
                key={idx}
                id={idx}
                type={type}
                inputMode={inputMode}
                className={`form-input ${key}`}
                maxLength={1}
                value={num}
                onChange={e => processInput(e, idx)}
                onKeyUp={e => onKeyUp(e, idx)}
                ref={ref => inputs.current.push(ref)}
              />
            </div>
          );
        })}
      </div>
      {error === 'code' && <p className={'error'}>{errorMessage}</p>}
    </div>
  );
};

export default CodeVerificationInput;
